import { client } from './client'

const fetchCallerRegions = async (countryId) => {
  try {
    let response = await client.get('/v1/callerregions/countries/' + countryId)
    return response.data
  } catch (error) {
    throw error
  }
}

const putCallerRegion = async (data) => {
  try {
    let response = await client.put('/v1/callerregions/number/' + data.endpoint, {
      areaId: data.areaId
    })
    return response.data
  } catch (error) {
    throw error
  }
}
export {
  fetchCallerRegions,
  putCallerRegion
}



// WEBPACK FOOTER //
// ./src/api/calling/index.js